document.addEventListener('DOMContentLoaded', async () => {
  const containers = document.querySelectorAll('.additionalButtons');

  for (const container of containers) {
    const productHandle = container.dataset.productHandle;

    const types = [
      { type: 'SubstituteProducts', key: 'substitute' },
      { type: 'RelatedProducts', key: 'related' },
      { type: 'CompleteTheLook', key: 'accessories' }
    ];

    for (const { type, key } of types) {
      const raw = container.dataset[key];
      let parsedList;

      try {
        parsedList = JSON.parse(raw);
      } catch (e) {
        console.warn(`Invalid or missing JSON for "${key}" on product "${productHandle}"`, e);
        continue;
      }

      const handles = [...new Set(
        parsedList
          .map(item => item.SKU?.trim())
          .filter(Boolean)
      )];

      let hasAvailable = false;

      for (const handle of handles) {
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) continue;

          const product = await res.json();
          const available = product.variants.some(v => v.available);

          if (available) {
            hasAvailable = true;
            break;
          }
        } catch (err) {
          console.error(`Error fetching ${key} product "${handle}"`, err);
        }
      }

      if (hasAvailable) {
        const button = container.querySelector(
          `.additionalProductsButton[data-additionalProductType="${type}"]`
        );
        if (button) {
          button.classList.remove('hidden');
        }
      }
    }
  }
});
